module.exports = __webpack_public_path__ + "img/i_x_input.099f3a63.svg";